module.exports = __webpack_public_path__ + "static/media/poster_image.d1949774.jpg";